import type { GcsPath } from "@/components/common/GcsImage";

interface Agent {
  name: string;
  title: string;
  location: string;
  slug: string;
  avatar: GcsPath;
  license?: string;
}

export const agentsTeam: Agent[] = [
  {
    name: "Alexis L.",
    title: "Licensed Insurance Agent",
    slug: "alexis-l",
    avatar: "images/careers/Shield - Alexis Lopez.webp",
    location: "Los Angeles, CA",
    license: "0L83377",
  },
  {
    name: "Amanda G.",
    title: "Licensed Insurance Agent",
    slug: "amanda-g",
    avatar: "images/careers/amanda-m-avatar.webp",
    location: "Simi Valley, CA",
    license: "0E91121",
  },
  {
    name: "Andrea T.",
    title: "Licensed Insurance Agent",
    slug: "andrea-t",
    avatar: "images/careers/andrea-avatar-new.webp",
    location: "Raleigh, NC",
    license: "21187209",
  },
  {
    name: "Brandon S.",
    title: "Licensed Insurance Agent",
    slug: "brandon-s",
    avatar: "images/careers/brandon-sizemore-avatar.webp",
    location: "Sarasota, FL",
    license: "19290759",
  },
  {
    name: "Brian A.",
    title: "Licensed Insurance Agent",
    slug: "brian-a",
    avatar: "images/careers/brian-aga-avatar.webp",
    location: "Virginia",
    license: "2055499",
  },
  {
    name: "Daniel T.",
    title: "Licensed Insurance Agent",
    slug: "daniel-t",
    avatar: "images/careers/Shield - Daniel T.webp",
    location: "Los Angeles, CA",
    license: "20659917",
  },
  {
    name: "Diane M.",
    title: "Licensed Insurance Agent",
    slug: "diane-m",
    avatar: "images/careers/Shield - Diane Marrero.webp",
    location: "Boynton Beach, FL",
    license: "21277219",
  },
  {
    name: "Eric B.",
    title: "Licensed Insurance Agent",
    slug: "eric-b",
    avatar: "images/careers/eric-avatar-new.webp",
    location: "Fremont, NC",
    license: "19625464",
  },
  {
    name: "Frankie C.",
    title: "Licensed Insurance Agent",
    slug: "frankie-c",
    avatar: "images/careers/frankie-avatar.webp",
    location: "Phoenix, AZ",
    license: "20840542",
  },
  {
    name: "Jacinda Q.",
    title: "Licensed Insurance Agent",
    slug: "jacinda-q",
    avatar: "images/careers/jacinda-q-avatar.webp",
    location: "New York, NY",
    license: "PC-1338535",
  },
  {
    name: "Jerrica M.",
    title: "Licensed Insurance Agent",
    slug: "jerrica-m",
    avatar: "images/careers/Shield - Jerrica Medina.webp",
    location: "San Antonio, TX",
    license: "2148766",
  },
  {
    name: "Joey F.",
    title: "Licensed Insurance Agent",
    slug: "joey-f",
    avatar: "images/careers/Shield - Joey Felix.webp",
    location: "Corona, CA",
    license: "0L35184",
  },
  {
    name: "Jorge O.",
    title: "Licensed Insurance Agent",
    slug: "jorge-o",
    avatar: "images/careers/jorge-o-avatar.webp",
    location: "Chicago, IL",
    license: "19418339",
  },
  {
    name: "Katie L.",
    title: "Licensed Insurance Agent",
    slug: "katie-l",
    avatar: "images/careers/katie-avatar.webp",
    location: "Madison, WI",
    license: "19908584",
  },
  {
    name: "Laura C.",
    title: "Licensed Insurance Agent",
    slug: "laura-c",
    avatar: "images/careers/laura-avatar-new.webp",
    location: "Raleigh, NC",
    license: "20989791",
  },
  {
    name: "Linh S.",
    title: "Licensed Insurance Agent",
    slug: "linh-s",
    avatar: "images/careers/linh-avatar.webp",
    location: "Minneapolis, MN",
    license: "20259207",
  },
  {
    name: "Matthew C.",
    title: "Licensed Insurance Agent",
    slug: "matthew-c",
    avatar: "images/careers/matthew-avatar-new.webp",
    location: "Raleigh, NC",
    license: "21160014",
  },
  {
    name: "Melissa M.",
    title: "Licensed Insurance Agent",
    slug: "melissa-m",
    avatar: "images/careers/melissa-avatar.webp",
    location: "Jacksonville, FL",
    license: "G033479",
  },
  {
    name: "Nate B.",
    title: "Licensed Insurance Agent",
    slug: "nate-b",
    avatar: "images/careers/nate-brown-avatar.webp",
    location: "Spokane, WA",
    license: "20337584",
  },
  {
    name: "Omar O.",
    title: "Licensed Insurance Agent",
    slug: "omar-o",
    avatar: "images/careers/omar-avatar.webp",
    location: "Chicago, IL",
    license: "17950791",
  },
  {
    name: "Reid B.",
    title: "Licensed Insurance Agent",
    slug: "reid-b",
    avatar: "images/careers/reid-beer-avatar.webp",
    location: "Kansas City, MO",
    license: "18501248",
  },
  {
    name: "Sabrina C.",
    title: "Licensed Insurance Agent",
    slug: "sabrina-c",
    avatar: "images/careers/sabrina-clark-avatar.webp",
    location: "Dayton, OH",
    license: "1435777",
  },
  {
    name: "Sarah P.",
    title: "Licensed Insurance Agent",
    slug: "sarah-p",
    avatar: "images/careers/sarah-avatar-new.webp",
    location: "St. Augustine, FL",
    license: "20151060",
  },
  {
    name: "Seth W.",
    title: "Licensed Insurance Agent",
    slug: "seth-w",
    avatar: "images/careers/seth-walden-avatar.webp",
    location: "Columbia, SC",
    license: "18726475",
  },
  {
    name: "Sophie B.",
    title: "Licensed Insurance Agent",
    slug: "sophie-b",
    avatar: "images/careers/sophie-bryant-avatar.webp",
    location: "Columbus, OH",
    license: "21154114",
  },
  {
    name: "Steve C.",
    title: "Licensed Insurance Agent",
    slug: "steve-c",
    avatar: "images/careers/steve-avatar.webp",
    location: "Seattle, WA",
    license: "16488683",
  },
  {
    name: "Tessa B.",
    title: "Licensed Insurance Agent",
    slug: "tessa-b",
    avatar: "images/careers/tessa-b-avatar.webp",
    location: "Columbus, OH",
    license: "1432376",
  },
  {
    name: "Thomas M.",
    title: "Licensed Insurance Agent",
    slug: "thomas-m",
    avatar: "images/careers/thomas-m-avatar.webp",
    location: "Eau Claire, WI",
    license: "18203341",
  },
  {
    name: "Tyson R.",
    title: "Licensed Insurance Agent",
    slug: "tyson-r",
    avatar: "images/careers/tyson-avatar.webp",
    location: "Pueblo, CO",
    license: "18758337",
  },
  {
    name: "Wayne C.",
    title: "Licensed Insurance Agent",
    slug: "wayne-c",
    avatar: "images/careers/wayne-c-avatar.webp",
    location: "Bay Village, OH",
    license: "16477729",
  },
];

export interface AgentsData {
  name: string;
  title: string;
  email?: string;
  linkedin: string;
  image: GcsPath;
  bio: string;
  education: string;
  expertise: string;
  credentials: string;
  passion: string;
  quote?: string;
  quoteAuthor?: string;
  license: string;
  location: string;
}

export const agents: Record<string, AgentsData> = {
  "alexis-l": {
    name: "Alexis Lopez",
    title: "Licensed Insurance Agent",
    license: "0L83377",
    location: "Los Angeles, CA",
    bio: "Alexis is a licensed agent with a decade of experience in both commercial and personal lines insurance. With experience in both captive and brokerage agencies, he has assisted thousands of families in seeking the protection they need at an affordable rate. Alexis is bilingual and has worked on both the account management side and the sales side, so he is able to assist clients in any situation they find themselves in. As a top performer, Alexis has held senior titles and team lead positions throughout his career.",
    education:
      "Associate Degree in Business Administration / Associate in Insurance (AINS) / Construction Risk and Insurance Specialist (CRIS)",
    expertise:
      "Commercial and personal insurance lines, including General Liability, Workers' Compensation, Home, and Auto insurance",
    credentials: "Property and Casualty Broker/Agent in all 50 states",
    passion:
      "Growing as an individual, trying new restaurants and steakhouses, and spending time with my wife and two daughters.",
    quote:
      "When you stand before God, you cannot say 'But I was told by others to do thus' or that 'virtue was not convenient at the time.' This will not suffice.",
    quoteAuthor: "",
    email: "alexis.lopez@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/alexis-lopez-ains-cris-67b855103/",
    image: "images/careers/Shield - Alexis Lopez.webp",
  },

  "amanda-g": {
    name: "Amanda G.",
    title: "Licensed Insurance Agent",
    license: "0E91121",
    location: "Simi Valley, CA",
    bio: "Amanda is a licensed personal lines insurance agent who helps people protect what matters most — their homes, cars, and the life they've worked hard to build. Her role is to guide clients through their coverage options, making sure they understand their protection while helping them find the best balance of coverage and price. She focuses on educating and advocating for her clients so they can feel confident and secure in their insurance decisions.",
    education: "A.S., Business Management at University of Phoenix",
    expertise:
      "Car Insurance, Home Insurance, Umbrella Policies, Renters Insurance, Boat insurance, Personal Articles Floater Insurance",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion:
      "Spending time with my family and friends, Camping, Road trips, Football, Concerts and my Pups",
    quote: "Luck favors the prepared.",
    quoteAuthor: "Edna Mode, Incredibles",
    email: "amanda.granados@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/amanda-granados-953569290/",
    image: "images/careers/amanda-m-avatar.webp",
  },

  "andrea-t": {
    name: "Andrea T.",
    title: "Licensed Insurance Agent",
    license: "21187209",
    location: "Raleigh, NC",
    bio: "Andrea Tysor is a licensed insurance agent known for turning complex insurance policies into clear, customized solutions for her clients. With a strong grasp of risk management strategies and a talent for building lasting client relationships, Andrea is a true advocate, always negotiating to secure the best possible coverage options. Her success stems from a mix of strategic sales tactics, proactive problem-solving, and a people-first approach that keeps customer satisfaction front and center. Whether she's growing a book of business or navigating tricky claims, Andrea brings energy, expertise, and a results-driven mindset to everything she does.",
    education: "B.A., Political Science at Hood College",
    expertise: "Personal Property Insurance",
    credentials: "Licensed Insurance Agent",
    passion:
      "Traveling with my family, reading books, and being around animals",
    quote:
      "People will forget what you said, but they will never forget how you made them feel.",
    quoteAuthor: "Maya Angelou",
    email: "andrea.tysor@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/andrea-tysor-577344232/",
    image: "images/careers/andrea-avatar-new.webp",
  },

  "brandon-s": {
    name: "Brandon S.",
    title: "Licensed Insurance Agent",
    license: "19290759",
    location: "Sarasota, FL",
    bio: "Brandon helps clients cut through the confusion and get insurance that actually makes sense. With over 7 years of experience, he works closely with each client to understand their needs and build smart, cost-effective coverage across home, auto, and umbrella policies. His approach is simple: clear guidance, honest advice, and protection you can count on when it matters most.",
    education: "",
    expertise:
      "Car Insurance, Home Insurance, Umbrella Policies, Renters Insurance, Motorcycles, Boats, RVs, Earthquake, Flood & Personal Articles Floater Insurance",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion:
      "Traveling, spending time with family and my Cocker Spaniel Boomer. Love doing car meets and being active in the local car community.",
    email: "brandon.sizemore@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/brandon-sizemore-9534a639/",
    image: "images/careers/brandon-sizemore-avatar.webp",
  },

  "brian-a": {
    name: "Brian Aga",
    title: "Licensed Insurance Agent",
    license: "2055499",
    location: "Virginia",
    bio: "Brian is a licensed insurance agent serving clients across Virginia. He helps homeowners and families understand their coverage options, compare plans with clarity, and choose protection that fits their needs and budget.",
    education: "",
    expertise:
      "Home Insurance, Auto Insurance, Umbrella Policies, Renters Insurance",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion:
      "Helping Virginia families feel confident about their coverage and spending time with loved ones.",
    linkedin: "",
    image: "images/careers/brian-aga-avatar.webp",
  },

  "daniel-t": {
    name: "Daniel T.",
    title: "Licensed Insurance Agent",
    license: "20659917",
    location: "Los Angeles, CA",
    bio: "Daniel Tercero is a licensed insurance advisor with a background in personal lines and client relationship management. He focuses on helping individuals and families understand their coverage options and find protection that fits their needs. With a commitment to clear communication and dependable service, Daniel works to ensure every client feels confident and supported throughout the insurance process.",
    education: "Interior Design, Chaffey College",
    expertise: "Car, home, umbrella, boat, personal articles",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion:
      "Brazilian jiu jitsu, Phototherapy, Interior design, Fashion, and family/friends.",
    quote:
      "The only way to make sense out of change is to plunge into it, move with it, and join the dance.",
    quoteAuthor: "Alan Watts",
    email: "daniel.tercero@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/danieletercero/",
    image: "images/careers/Shield - Daniel T.webp",
  },

  "diane-m": {
    name: "Diane Marrero",
    title: "Licensed Insurance Agent",
    license: "21277219",
    location: "Boynton Beach, FL",
    bio: "Diane has been a licensed agent since 2024 and is passionate about helping people find the right insurance coverage for their individual needs. She takes the time to get to know each client so she can match them with options that make sense for their situation. She is here and ready to help every client feel confident in their coverage.",
    education: "Associate Degree, Marketing Management",
    expertise: "Home Insurance, Car Insurance, and Landlord/Renters Insurance",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion:
      "Spending time with my dog, Rockie, visiting parks and beaches on weekends, and exploring local coffee shops while traveling.",
    quote:
      "Sometimes all you need is 20 seconds of insane courage. Just literally 20 seconds of embarrassing bravery. And I promise you, something great will come of it.",
    quoteAuthor: "We Bought a Zoo",
    email: "diane.marrero@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/diane-marrero-32a70a149/",
    image: "images/careers/Shield - Diane Marrero.webp",
  },

  "eric-b": {
    name: "Eric B.",
    title: "Licensed Insurance Agent",
    license: "19625464",
    location: "Fremont, NC",
    bio: "Eric has been an insurance agent since 2020 and over the past couple of years has honed in on an area of expertise in the personal lines market. He has worked in leadership roles as a trainer and new business development as well as new business sales across different independent agencies in the Tampa Bay area before relocating to the Raleigh area.",
    education: "Louisburg College",
    expertise:
      "Home Insurance, Car Insurance, Umbrella Policies, Renters Insurance, Boat Insurance, Personal Articles Floater Insurance",
    credentials: "Licensed Insurance Producer, Property and Casualty",
    passion:
      "I've been coaching high school football since 2012 and have still continued to help out behind the scenes for a couple of schools in other states. I also thoroughly enjoy going to concerts and going to Atlanta at least once a year to root on the Braves.",
    quote:
      "Failure is a part of success. There is no such thing as a bed of roses all your life. But failure will never stand in the way of success if you learn from it.",
    quoteAuthor: "Hank Aaron",
    email: "eric.bushey@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/eric-bushey-497718aa/",
    image: "images/careers/eric-avatar-new.webp",
  },

  "frankie-c": {
    name: "Frankie C.",
    title: "Licensed Insurance Agent",
    license: "20840542",
    location: "Phoenix, AZ",
    bio: "Frankie is a licensed insurance agent dedicated to demystifying the complexities of coverage. With a background spanning major carriers and key roles at Goosehead Insurance and Matic, Frankie pairs deep product knowledge with an analytical eye for market trends. He specializes in translating nuanced insurance products into actionable advice, ensuring every client feels confident in their coverage selection. His approach is simple: protect the client's assets as if they were his own.",
    education: "",
    expertise:
      "Car Insurance, Home Insurance, Umbrella Insurance, Renters Insurance, Boat Insurance, Personal Articles Floater Insurance, Earthquake Insurance, Builders Risk Insurance, General Liability Policies, and Commercial Policies",
    credentials: "Licensed Property and Casualty Producer, Personal Lines",
    passion:
      "Outside of the office, Frankie is an avid outdoorsman who enjoys mountain hiking and camping. A creative at heart, he spends his free time playing music and designing digital art. Above all, he cherishes quality time at home with his family and their animals.",
    quote: "Do or do not. There is no try.",
    quoteAuthor: "Yoda",
    email: "frankie.cardona@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/frankie-cardona-059103253/",
    image: "images/careers/frankie-avatar.webp",
  },

  "jerrica-m": {
    name: "Jerrica Medina",
    title: "Licensed Insurance Agent",
    license: "2148766",
    location: "San Antonio, TX",
    bio: "Jerrica is a personal lines insurance sales professional with a strong foundation in consultative selling, relationship building, and guiding clients through important financial decisions. At Guardian Service, she connects clients with tailored solutions through strategic partnerships while delivering a trust-centered experience. She is focused on not just closing business, but making a lasting impact with her clients and the organization.",
    education: "",
    expertise:
      "Car Insurance, Home Insurance, Umbrella Policies, Renters Insurance, Boat Insurance, Personal Articles Floater Insurance, and Utility Line Warranties",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion:
      "Spending time with friends and family, traveling, exploring new recipes, anything sports-related, concerts, and a good book.",
    quote: "Be yourself; everyone else is already taken.",
    quoteAuthor: "Oscar Wilde",
    email: "jerrica.medina@guardianservice.com",
    linkedin: "",
    image: "images/careers/Shield - Jerrica Medina.webp",
  },

  "joey-f": {
    name: "Joey Felix",
    title: "Licensed Insurance Agent",
    license: "0L35184",
    location: "Corona, CA",
    bio: "Joey is an experienced insurance professional with over 10 years in the industry, specializing in both personal lines and commercial coverage. Throughout his career, he has focused on building strong, lasting relationships with clients by delivering exceptional service and tailored insurance solutions. He is committed to understanding each client's unique needs, helping individuals protect what matters most while supporting businesses in managing risk and achieving sustainable growth. With a proven track record of high sales production, he takes pride in combining industry expertise with a customer-first approach to drive results and long-term success.",
    education: "Golden West College",
    expertise:
      "Car Insurance, Home Insurance, Umbrella Policies, Renters Insurance, Boat Insurance, Personal Articles Floater Insurance, and Rental Properties",
    credentials: "Property and Casualty Licensed",
    passion:
      "Outside of work, I enjoy hands-on projects and building from the ground up. Over the past three years, I completed a full home remodel, taking on everything from painting and flooring to concrete work and lighting, and I enjoy learning new skills along the way. I also built a fully customized camper van with a shower, solar power, and off-grid capabilities. In my free time, I enjoy camping, boating, exploring local breweries, and spending time with family and friends.",
    quote: "If God brings you to it, He will bring you through it.",
    quoteAuthor: "",
    email: "joey.felix@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/joey-felix-140b82159/",
    image: "images/careers/Shield - Joey Felix.webp",
  },

  "jonathan-r": {
    name: "Jonathan R.",
    title: "VP of Insurance",
    license: "18576371",
    location: "Raleigh, NC",
    bio: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    education:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    expertise:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    credentials:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore.",
    passion:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    quoteAuthor: "Author Name",
    email: "jonathan.ruggiero@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/jonathan-ruggiero-4b59aa123/",
    image: "images/careers/jonathan-avatar-new.webp",
  },

  "kristi-w": {
    name: "Kristi W.",
    title: "Insurance Manager",
    license: "12484044",
    location: "Raleigh, NC",
    bio: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    education:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    expertise:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    credentials:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore.",
    passion:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    quoteAuthor: "Author Name",
    email: "kristi.ware@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/kristi-ware-2b93631a/",
    image: "images/careers/kristi-avatar-new.webp",
  },

  "katie-l": {
    name: "Katie L.",
    title: "Licensed Insurance Agent",
    license: "19908584",
    location: "Madison, WI",
    bio: "Katie has been a licensed agent since May of 2021. She is used to a fast paced environment as she spent her career working at Kin Insurance and specializing in home insurance. She is passionate about getting to know you and your situation to help you find the best policy for all of your insurance needs! ",
    education: "Associates Degree, Madison Area Technical College",
    expertise: "Personal Lines Insurance: Home, Auto, and Umbrella Insurance",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion:
      "Spending time with my fiance, Jacob, and our 4 month old baby boy, Hayden. We love going on long walks around our neighborhood, and hanging out with our family and friends!",
    quote:
      "I've learned that people will forget what you said, people will forget what you did, but people will never forget how you made them feel.",
    quoteAuthor: "Maya Angelou",
    email: "katie.rohde@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/katelynrohde/",
    image: "images/careers/katie-avatar.webp",
  },

  "laura-c": {
    name: "Laura C.",
    title: "Licensed Insurance Agent",
    license: "20989791",
    location: "Raleigh, NC",
    bio: "Laura is a licensed insurance agent who thrives on helping customers find the right coverage so that all their assets are properly protected. She wants to make sure every customer who comes her way walks away knowing what every coverage on their policy means and any coverage gaps they may have are filled.",
    education: "B.A., Communication at Loyola University Chicago",
    expertise:
      "Homeowners Insurance, Auto Insurance, Condo Insurance, Renters Insurance, Umbrella Policies, Personal Articles Floater Insurance, Pet Insurance",
    credentials: "Licensed Insurance Producer, Property and Casualty",
    passion: "Hiking, cooking, going to concerts, traveling, exploring",
    quote: "Be yourself; everyone else is already taken.",
    quoteAuthor: "Oscar Wilde",
    email: "laura.carranzo@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/lcarranza12/",
    image: "images/careers/laura-avatar-new.webp",
  },

  "linh-s": {
    name: "Linh S.",
    title: "Licensed Insurance Agent",
    license: "20259207",
    location: "Minneapolis, MN",
    bio: "Linh is a licensed insurance agent for personal lines who has proven results in finding the best fit for individuals and families to protect what matters most. Linh takes a consultative and straight-forward approach. Her best attribute is building relationships and being responsive with honesty and swiftness to reach the member's goals.",
    education:
      "Bachelors in Communication at University of Minnesota Twin Cities",
    expertise:
      "Home, Auto, Umbrella, Renters Insurance, Boat insurance, Personal Articles",
    credentials: "Licensed Insurance Producer, Personal Lines and Life/Health",
    passion:
      "Being active with my family in all of our activities, loves sports, working out and playing with our dog. Traveling more and more...and the goal is to keep adding new places!",
    quote: "Don't take life too seriously, you will never get out alive.",
    quoteAuthor: "",
    email: "linh.stanaway@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/linh-stanaway-00b98010/",
    image: "images/careers/linh-avatar.webp",
  },

  "matthew-c": {
    name: "Matthew C.",
    title: "Licensed Insurance Agent",
    license: "21160014",
    location: "Raleigh, NC",
    bio: "Matthew is a licensed agent who enjoys going above and beyond to make the insured feel well insured. He enjoys working as a team with his fellow Guardian Service agents.",
    education: "Easton High",
    expertise:
      "Auto insurance, Homeowners insurance, Personal umbrella policies, Renters insurance, Landlord policies, Personal articles policies",
    credentials: "Licensed Insurance Producer",
    passion:
      "Being outside in nice weather, going to the beach or mountains, kayaking and riding bikes",
    quote: "I like turtles.",
    quoteAuthor: "Matthew C.",
    email: "matthew.cherba@guardianservice.com",
    linkedin: "",
    image: "images/careers/matthew-avatar-new.webp",
  },

  "melissa-m": {
    name: "Melissa M.",
    title: "Licensed Insurance Agent",
    license: "G033479",
    location: "Jacksonville, FL",
    bio: "Melissa is a licensed insurance agent with more than a decade of industry experience. She specializes in personal lines and has deep expertise working across major catastrophic‑risk states. Her background includes key roles at Guardian Service, Kin, and ACSC (AAA), where she consistently delivered strong results and supported high‑volume customer needs. Melissa thrives in fast‑paced environments and excels as part of a high‑performing, collaborative team. Her blend of technical knowledge, adaptability, and customer‑focused service makes her a valuable asset in any insurance operation.",
    education: "A.S. Business Administration",
    expertise:
      "Home Insurance, Auto Insurance, Renters Insurance, Umbrella, and Boat Insurance",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion:
      "Long bike ride on the coast, adventures with the dogs, and reading a good book by the pool.",
    quote: "Stay Hard!",
    quoteAuthor: "David Goggins",
    email: "melissa.mazurowski@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/melissa-m-11a6282a3/",
    image: "images/careers/melissa-avatar.webp",
  },

  "nate-b": {
    name: "Nate B.",
    title: "Licensed Insurance Agent",
    license: "20337584",
    location: "Spokane, WA",
    bio: "Nate is a licensed insurance agent with a passion for proper protection who has helped thousands of households find the right insurance for their Home, Car, and any other insurance and financial needs throughout his career. With extensive experience working with dozens of major carriers such as State Farm, Liberty Mutual and Allstate, he excels in identifying how to make sure you have the right policy to fit your needs, while leveraging discounts and state of the art technology to make the user experience a breeze! His simple, service-driven approach makes him a valuable asset on the Guardian Service team and to American households across the U.S.!",
    education:
      "Communications/Sports Marketing at Eastern Washington University",
    expertise:
      "Car Insurance, Home Insurance, Umbrella Policies, Renters Insurance, Boat insurance, Personal Articles Floater Insurance, Life insurance, Health Insurance",
    credentials:
      "Property and Casualty License; Life, Health and Disability License",
    passion:
      "My Highschool Sweetheart, My Fur-babies, Boating, Outdoors, Sports, Concerts, Coaching Basketball and Volunteering in the community",
    quote: "As you start to walk on the way, the way appears.",
    quoteAuthor: "Rumi",
    email: "nate.brown@guardianservice.com",
    linkedin: "",
    image: "images/careers/nate-brown-avatar.webp",
  },

  "omar-o": {
    name: "Omar O.",
    title: "Licensed Insurance Agent",
    license: "17950791",
    location: "Chicago, IL",
    bio: "Omar Orellana is a licensed insurance consultant with over a decade of experience helping clients protect what matters most. His background spans both traditional and fintech start-up environments, including State Farm and Kin Insurance, giving him a well-rounded perspective on insurance operations. He is known for building trust, simplifying complex situations, and consistently delivering a seamless customer experience.",
    education: "B.S. Applied Mathematics",
    expertise:
      "High Net Worth Specialist, Car Insurance, Home Insurance, Umbrella Policies, Personal Articles Policies, Landlord Policies, Boat Insurance",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion: "Sports, hanging with family, vacations on the beach.",
    quote: "Do you understand the words that are coming out of my mouth.",
    quoteAuthor: "Jackie Chan",
    email: "omar.orellana@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/omar-orellana-957941331/",
    image: "images/careers/omar-avatar.webp",
  },

  "reid-b": {
    name: "Reid B.",
    title: "Licensed Insurance Agent",
    license: "18501248",
    location: "Kansas City, MO",
    bio: "Reid is a licensed insurance producer in all 50 states and DC with many years of experience. Drawing on a diverse background that includes time at major insurance carriers like Liberty Mutual, local agencies, and startups, he not only utilizes this wide breadth of knowledge to offer customized coverage but also focuses on educating his customers. Reid believes in empowering his clients to fully understand their insurance options and make informed decisions, ensuring the coverage meets their needs and budget at every point in life's journey.",
    education: "The University of Kansas",
    expertise:
      "Car Insurance, Home Insurance, Renters Insurance, Condo Insurance, Umbrella Insurance, Motorcycle Insurance, Boat Insurance, RV Insurance, Travel Trailer Insurance, ATV Insurance, Golf Cart Insurance, Jewelry Insurance",
    credentials: "Licensed Insurance Producer, Property and Casualty",
    passion:
      "Traveling, especially international travel and cruises; and my birds and cats",
    quote:
      "To see the world, things dangerous to come to, to see behind walls, draw closer, to find each other, and to feel. That is the purpose of life.",
    quoteAuthor: "The Secret Life of Walter Mitty",
    email: "reid.beer@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/reid-beer/",
    image: "images/careers/reid-beer-avatar.webp",
  },

  "sabrina-c": {
    name: "Sabrina C.",
    title: "Licensed Insurance Agent",
    license: "1435777",
    location: "Dayton, OH",
    bio: "Sabrina is a dedicated sales agent at Guardian Service, focused on helping clients find reliable solutions that meet their needs. In her role, she builds strong relationships, provides clear guidance, and ensures every customer feels confident in their decisions. Her goal is to deliver excellent service while driving results for both her clients and her team.",
    education: "Hondros College of Business",
    expertise:
      "New Home Buyers, Home Insurance, Auto Coverage, Rental Insurance, Rental Home Coverage, ATV/UTV Coverage",
    credentials:
      "Licensed Insurance Producer, Personal Lines; Notary Public for Ohio",
    passion:
      "Getting out in the woods with my family, and bringing my kids on new adventures",
    quote:
      "Do the best you can until you know better. Then when you know better, do better.",
    quoteAuthor: "Maya Angelou",
    email: "sabrina.clark@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/sclarkagency/",
    image: "images/careers/sabrina-clark-avatar.webp",
  },

  "sarah-p": {
    name: "Sarah P.",
    title: "Licensed Insurance Agent",
    license: "20151060",
    location: "St. Augustine, FL",
    bio: "Sarah is a licensed insurance sales agent with a proven history of exceptional performance. Her approach is built on a foundation of trust and genuine connection, prioritizing the building of strong rapport with every client. Sarah believes that a well-informed customer is an empowered customer. She invests her time in thoroughly educating her clients about their options, ensuring they understand their coverage and feel confident in their insurance decisions. With a deep understanding in the insurance landscape and a personalized, educational approach, Sarah is dedicated to helping individuals and families find the right coverage for their needs.",
    education: "",
    expertise: "Home Insurance, Landlord Insurance, High Value Homes",
    credentials:
      "Licensed Insurance Producer, Personal Lines and Property and Casualty",
    passion:
      "In my free time, I enjoy working with my entrepreneurial husband serving the community, providing alcohol alternatives and a safe space for entertaining. I also enjoy taking long walks with my 80lb furbaby.",
    quote: "Do or do not. There is no try.",
    quoteAuthor: "Yoda",
    email: "sarah.prasil@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/sarah-prasil-28769a135/",
    image: "images/careers/sarah-avatar-new.webp",
  },

  "steve-c": {
    name: "Steve C.",
    title: "Licensed Insurance Agent",
    license: "16488683",
    location: "Seattle, WA",
    bio: "Steve is a property and casualty insurance agent known for turning complex coverage needs into simple, confident decisions for his clients. Blending strategy, empathy, and sales excellence, Steve is committed to protecting what matters most while delivering an exceptional customer experience.",
    education: "B.S. at the University of Colorado",
    expertise:
      "Homeowners Insurance, Auto Insurance, Umbrella, Personal Articles",
    credentials: "Licensed Property and Casualty Producer",
    passion:
      "Spending as much time with the family as possible. Beach time, hiking trails, boating or anything outdoors.",
    quote:
      "If you think you are too small to make a difference, try sleeping with a mosquito.",
    quoteAuthor: "Dalai Lama",
    email: "steve.calleja@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/stephen-calleja/",
    image: "images/careers/steve-avatar.webp",
  },

  "thomas-m": {
    name: "Thomas M.",
    title: "Licensed Insurance Agent",
    license: "18203341",
    location: "Eau Claire, WI",
    bio: "Thomas is a licensed insurance professional with over eight years of experience at Liberty Mutual, followed by key roles at high-growth startups including Steadily and Trellis. Having worked across multiple teams and helped launch nationwide insurance products, Thomas brings a proven track record of high performance and award-winning results. Licensed in all 50 states and experienced with more than 80 insurance carriers, he excels in digital communication and delivering tailored solutions that meet clients where they are.",
    education: "Daytona State",
    expertise:
      "Car Insurance, Home Insurance, Umbrella Policies, Renters Insurance, Motorcycles, Boats, RVs",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion: "Traveling, my dogs, my family and Taco Bell",
    quote: "You miss 100% of the shots you don't take. - Wayne Gretzky",
    quoteAuthor: "Michael Scott",
    email: "thomas.mclaughlin@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/thomas-mclaughlin2289/",
    image: "images/careers/thomas-m-avatar.webp",
  },

  "tyson-r": {
    name: "Tyson R.",
    title: "Licensed Insurance Agent",
    license: "18758337",
    location: "Pueblo, CO",
    bio: "Tyson is an experienced insurance agent with over seven years of expertise helping clients simplify the insurance shopping process. He has assisted individuals and families in all 50 states and brings extensive experience working with multiple insurance carriers. He specializes in helping clients find coverage that fits their unique needs.",
    education: "",
    expertise:
      "Car Insurance, Home Insurance, Umbrella Policies, Renters Insurance, Boat insurance, Personal Articles Floater Insurance, Motorcycle and Toy Insurance, and Mobile Home Insurance",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion:
      "Riding dirtbikes, working on cars, fishing, and being outside with my dog.",
    quote: "Do something today to make for a better tomorrow.",
    quoteAuthor: "",
    email: "tyson.reich@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/tyson-reich-aaa328387/",
    image: "images/careers/tyson-avatar.webp",
  },

  "wayne-c": {
    name: "Wayne C.",
    title: "Licensed Insurance Agent",
    license: "16477729",
    location: "Bay Village, OH",
    bio: "Wayne is a licensed insurance agent who prides himself on being the best part of your worst day by making comprehensive recommendations to cover each client's individual insurance needs. Wayne will uncover what means the most to you and makes sure you walk away knowing more about your insurance coverage than you did coming in.",
    education: "",
    expertise:
      "Auto Insurance, Home Insurance, Umbrella Policies, Renters Insurance, Personal Rider Policies, Long Term Rental Policies",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion:
      "Helping my son in his pursuit to be a professional Fortnite Player, walking our dogs and traveling",
    quote:
      "The most important thing is, whatever you decide to choose, take it seriously and do your best.",
    quoteAuthor: "Tom Sturridge",
    email: "wayne.cruz@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/wayne-cruz-153b0837",
    image: "images/careers/wayne-c-avatar.webp",
  },

  "seth-w": {
    name: "Seth W.",
    title: "Licensed Insurance Agent",
    license: "18726475",
    location: "Columbia, SC",
    bio: "Seth is an innovative insurance professional with a proven record of success in: Sales, Training, & Coaching. Seth has extensive experience with advising clients on their insurance needs, training new agents in the startup realm, and also managing captive agencies. He has held a leadership role at both Allstate and Matic and has been a licensed agent for over 8 years. His direct, personalized approach makes him a wonderful problem solver in a dynamic industry.",
    education: "B.S., Political Science at Lander University",
    expertise: "All personal line insurance (Auto, Home, Umbrella, Renters, Boat, Specialty, E&S lines)",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion: "Spending time with my wife and daughter, South Carolina gamecock sports, and travel",
    quote: "Always become a master. No one ignores the master.",
    quoteAuthor: "",
    email: "seth.walden@guardianservice.com",
    linkedin: "",
    image: "images/careers/seth-walden-avatar.webp",
  },

  "sophie-b": {
    name: "Sophie B.",
    title: "Licensed Insurance Agent",
    license: "21154114",
    location: "Columbus, OH",
    bio: "Sophie is a licensed insurance agent with a people-first approach. By combining expert guidance with genuine relationships (and a few giggles along the way), she helps people feel confident in their coverage and comfortable asking questions. Her goal is simple: make sure her clients always know someone has their back.",
    education: "Bachelors Degree, The Scripps College of Communication at Ohio University",
    expertise: "Home Insurance, Auto Insurance, Umbrella Policies, Renters Insurance, Personal Articles Floater Insurance, Boat Insurance, Motorcycle Insurance",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion: "I love cuddling with my rescue dog, Otis and my cat Peanut. I am very family oriented and try to spend as much time with them as I can. I am also an incredibly avid reader, my head is almost always buried in a book.",
    quote: "Come on, dance with me. The earth is spinning. We can't just stand on it.",
    quoteAuthor: "Dino Ahmetovic",
    email: "sophie.bryant@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/sophiachristinabryant/",
    image: "images/careers/sophie-bryant-avatar.webp",
  },

  "jorge-o": {
    name: "Jorge O.",
    title: "Licensed Insurance Agent",
    license: "19418339",
    location: "Chicago, IL",
    bio: "Jorge is an insurance producer with 8+ years of experience helping clients across personal and commercial lines find coverage that actually fits their lives. With a background spanning Kin Insurance, Honeycomb Insurance, and his own AI-powered insurance platform, he brings a rare combination of tech-forward thinking and boots-on-the-ground insurance expertise. Jorge is known for cutting through the jargon, asking the right questions, and making sure his clients are never underinsured when it matters most.",
    education: "MBA at University of Wisconsin-Madison; B.S. Economics at North Park University",
    expertise: "Car Insurance, Home Insurance, Renters Insurance, Umbrella Policies, Commercial Lines, Business Owner's Policy (BOP), Commercial Auto, Landlord Policies",
    credentials: "Licensed Insurance Producer, Personal Lines & Commercial Lines; MBA; CSPO; Scrum Alliance; ARM (In Progress)",
    passion: "Building things! Whether that's a business, a product, or a good playlist. Exploring Chicago's food scene, and reading a good book.",
    quote: "The best way to predict the future is to create it.",
    quoteAuthor: "Peter Drucker",
    email: "jorge.ortiz@guardianservice.com",
    linkedin: "http://linkedin.com/in/Jorge-s-ortiz",
    image: "images/careers/jorge-o-avatar.webp",
  },

  "tessa-b": {
    name: "Tessa B.",
    title: "Licensed Insurance Agent",
    license: "1432376",
    location: "Columbus, OH",
    bio: "Tessa is a licensed insurance advisor who enjoys helping people find coverage that fits their lives and gives them peace of mind. She believes insurance shouldn't be confusing, so she takes the time to explain options clearly and make the process as simple as possible. Known for her friendly approach, attention to detail, and commitment to help people, Tessa works hard to build relationships based on trust and dependable service. Whether she's helping someone choose a new policy or answering questions along the way, she's dedicated to making sure every person feels informed, supported, and confident in their coverage.",
    education: "B.A., Human Biology at Ohio University",
    expertise: "Personal Lines Insurance: Home, Car, Motorcycle, Boat, Camper, Umbrella, Renters, Jewelry and Flood Insurance",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion: "Hanging out with my friends, family and cats, live music, camping, skiing, biking around the city, trying new restaurants and recipes",
    quote: "Find out who you are and do it on purpose.",
    quoteAuthor: "Dolly Parton",
    email: "tessa.barnes@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/tessa-barnes-72b0b5218/",
    image: "images/careers/tessa-b-avatar.webp",
  },

  "jacinda-q": {
    name: "Jacinda Q.",
    title: "Licensed Insurance Agent",
    license: "PC-1338535",
    location: "New York, NY",
    bio: "Jacinda is a licensed insurance agent with 20 years of industry experience, having launched her career as an underwriting assistant. With a deep foundational knowledge or risk assessment, she expertly evaluates coverage options to ensure each client secures the optimal policy tailored to their specific needs.",
    education: "Bachelors in Business Management",
    expertise: "Personal Lines",
    credentials: "Licensed Insurance Producer, Personal Lines in 48 states",
    passion: "Outside of work, I’m a proud parent, a dog owner, and a massive fan of exploring everything the city has to offer—from hidden neighborhood gems to local cultural events. On any given weekend, you can find me wandering a local park trying to identify plants and birds or hunting down the best local spots.",
    quote: "Any time you have an opportunity to make a difference in this world and you don't, then you are wasting your time on Earth.",
    quoteAuthor: "Roberto Clemente",
    email: "jacinda.quinones@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/jacinda-quinones-187344229/",
    image: "images/careers/jacinda-q-avatar.webp",
  },
};
